<div class="learning-text-bar">
    <span class="adelle-sans-17 font-weight-300 dark-gray">
        Ihre dokumentierte Gesamtlernzeit beträgt:
        {{ currentLearnTimeInSeconds | secondsToHours: true }}&#160;von&#160;{{
            targetReadingTimeInHours
        }}&#160;Stunden
    </span>
</div>
